import * as handlers from "./handlers";
import { UseSlatePlugin } from "components/slate/types";

const useSoftBreakPlugin: UseSlatePlugin = () => {
  return {
    handlers,
  };
};

export default useSoftBreakPlugin;
